export default __webpack_public_path__ + "fr/static/media/logo-avis-verifies.2bf4802a.png";